const UrlKey = 'baseurl'

export function getUrl() {
  return localStorage.getItem(UrlKey)
}

export function setUrl(url) {
  return localStorage.setItem(UrlKey,url)
}

export function removeUrl() {
  return localStorage.removeItem(UrlKey)
}



// WEBPACK FOOTER //
// ./src/utils/baseurl.js